import React from 'react'

const ReviewQueuePage = () => {
  return (
    <div>ReviewQueuePage</div>
  )
}

export default ReviewQueuePage